import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { CircleIconButton } from '@/components/ui/Button/CircleIconButton';
import { AngleLeftIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
export const PrevButton = (props) => {
    const { className = '', currentSlide = 0, customClassName = '', dataAttributes = {}, disabled = false, minShowSlide = undefined, onClick = undefined, style = {}, } = props;
    const isDisabled = disabled ||
        (!(minShowSlide === null || minShowSlide === undefined) &&
            minShowSlide >= currentSlide);
    return (_jsx("button", Object.assign({ className: clsx('group', 'py-8 pl-8', isDisabled && 'cursor-not-allowed', 
        // FIXME: 既存のスタイル打ち消す用
        ['!bg-transparent', '!w-[56px] !h-[64px]'], className, customClassName), disabled: disabled, onClick: onClick, type: 'button' }, { children: _jsx(CircleIconButton, Object.assign({ className: '!flex justify-center items-center', icon: AngleLeftIcon, shadow: 'md', size: 'md', style: style, tagName: 'div' }, dataAttributes)) })));
};
